import {createClient} from 'contentful';
import {documentToReactComponents} from '@contentful/rich-text-react-renderer';
import Image from 'next/image';
import Head from 'next/head';
import Link from 'next/link';

const client = createClient({
    space: '4krmlu2sje8w',
    accessToken: 'cOWC9DNnKluhcuMEhemi6_rTywg05d9KN8xxTqZGgE4'
});

export async function getStaticPaths() {
    const res = await client.getEntries({content_type: 'lexicon'});

    const paths = res.items.map((item) => ({
        params: {slug: item.fields.slug},
    }));

    return {paths, fallback: false};
}

export async function getStaticProps({params}) {
    const res = await client.getEntries({
        content_type: 'lexicon',
        'fields.slug': params.slug,
        include: 2,
    });

    return {props: {lexiconEntry: res.items[0]}};
}

export default function LexiconEntryPage({lexiconEntry}) {
    const {title, bild, definition, verwandteBegriffe} = lexiconEntry.fields;

    const pageTitle = title + ' | deinSEOExpert';

    return (
        <div className="flex flex-col min-h-screen bg-gray-100 dark:bg-gray-900">
            <Head>
                <title>{pageTitle}</title>
                <link rel="icon" href="/favicon.ico"/>
            </Head>

            <header className="p-4 mt-4">
                <Link href="/lexikon" className="flex items-center text-gray-500 hover:text-blue-900">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            className="h-5 w-5 mr-1"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7"/>
                        </svg>
                        Zurück zum Lexikon

                </Link>
            </header>

            <main className="flex-grow p-6">
                <div className="max-w-3xl mx-auto">
                    <article>
                        <h1 className="text-4xl font-bold mb-4">{title}</h1>

                        {bild && (
                            <div className="mb-4">
                                <Image
                                    src={'https:' + bild.fields.file.url}
                                    width={bild.fields.file.details.image.width}
                                    height={bild.fields.file.details.image.height}
                                    alt={bild.fields.title}
                                />
                            </div>
                        )}

                        <div className="prose">{documentToReactComponents(definition)}</div>
                    </article>
                </div>
            </main>
        </div>
    );
}